import * as z from 'zod'
import {StocksFiltersSchema} from '@/modules/stocks/schemas'
import {SortSchema} from '@cypro/ui/schemas'
import {ReturnStatus} from '@cypro/engine/database/schema'

export const ReturnsFiltersSchema = StocksFiltersSchema.extend({
  stockLocations: z.array(z.uuidv7()).optional(),
  status: z.array(ReturnStatus).optional(),
})

export const ReturnsSearchSchema = z.object({
  filters: ReturnsFiltersSchema.default({status: [ReturnStatus.enum.AVAILABLE, ReturnStatus.enum.IN_USE]}),
  sort: z.array(SortSchema).default([{id: 'createdAt', desc: true}]),
})
